import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { Directive, forwardRef, inject, Type } from '@angular/core';
import { PhoneNumberValidatorService } from '../../services/phone-validator/phone-number-validator.service';

@Directive({
  selector: '[tdWbPhoneNumberValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: forwardRef((): Type<PhoneNumberValidatorDirective> => PhoneNumberValidatorDirective),
    multi: true
  }]
})
export class PhoneNumberValidatorDirective implements Validator {

  private readonly phoneNumberValidatorService = inject(PhoneNumberValidatorService);

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value) {
      return this.phoneNumberValidatorService.isValid(value) ? null : { invalidPhoneNumber: true };
    }
    return null;
  }
}
